import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';

import styles from './carousel.module.css';

export interface BusinessCarouselProps {
  elements?: JSX.Element[];
  settings?: BusinessProps;
}

export interface BusinessProps {
  arrows?: boolean;
  dots?: boolean;
  infinite?: boolean;
  speed?: number;
  slidesToShow?: number;
  slidesToScroll?: number;
  centerMode?: boolean;
  autoplay?: boolean;
  centerPadding?: string; // 10px
}

export default function BusinessCarousel(props: BusinessCarouselProps) {
  const sliderRef = useRef<Slider | null>(null);
  const windowSize = 300;
  const defaultSettings = {
    className: 'slider variable-width',
    arrows: false, // 배너 스타일에서는 화살표 없음
    dots: false, // 점도 없음
    infinite: true, // 무한 반복
    speed: 4000, // 하나 넘기는 데 8초 걸림
    autoplay: true, // 자동 재생
    autoplaySpeed: 0, // autoplay 간격 0 = 끊기지 않음
    cssEase: 'linear', // 부드럽게 이동
    slidesToShow: 2,
    slidesToScroll: 2,
    variableWidth: true, // 각 아이템 너비 고정
    pauseOnHover: false, // 마우스 올려도 멈추지 않게
    waitForAnimate: true, // 애니메이션 대기
  };

  useEffect(() => {
    const s = sliderRef.current;
    if (!s) return;

    s.slickGoTo(0, true);

    const handleResize = () => {
      s.slickGoTo(0, true);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Box component="div" className={`${styles['slider-container']}`}>
      {/* {...(props.settings || {})} 추가해야 밖에서 setting 설정해서 덮어 쓰기*/}
      <Slider ref={sliderRef} {...defaultSettings} {...(props.settings || {})}>
        {props?.elements?.map((el, index) => <div key={index}>{el}</div>)}
      </Slider>
    </Box>
  );
}
